export default __webpack_public_path__ + "static/media/suitemaster_4.72b93579.jpg";